import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const favouriteApi = createApi({
  reducerPath: 'favouriteApi',
  baseQuery: axiosBaseQuerySpotfinder({baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL}),
  tagTypes: ['favourite'],
  endpoints: builder => ({
    deleteCustomerFavourite: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerFavouriteController.deleteCustomerFavourite}${body.id}`,
          method: 'DELETE',
          headers: {Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    findAllCustomerFavourite: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerFavouriteController.findAllCustomerFavourite}`,
          method: 'POST',
          headers: {Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    findFavouriteByCustomerId: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerFavouriteController.findFavouriteByCustomerId}`,
          method: 'POST',
          headers: {Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    saveCustomerFavourite: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerFavouriteController.saveCustomerFavourite}`,
          method: 'POST',
          headers: {Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateCustomerFavourite: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerFavouriteController.updateCustomerFavourite}`,
          method: 'PUT',
          headers: {Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useDeleteCustomerFavouriteMutation,
  useFindFavouriteByCustomerIdMutation,
  useSaveCustomerFavouriteMutation,
  useUpdateCustomerFavouriteMutation,
  useFindAllCustomerFavouriteMutation,
} = favouriteApi;
